import { baseApi } from "../../api/baseApi";

const driveLinkApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDriveLink: builder.query({
      query: ({
        email,
        projectId,
        videoId,
        type,
      }: {
        email: string;
        projectId: string;
        videoId: string;
        type: string;
      }) => ({
        url: "/drive-link/generate-drive-link",
        method: "GET",
        params: {
          email,
          projectId,
          videoId,
          type,
        },
      }),
    }),
  }),
});

export const { useGetDriveLinkQuery } = driveLinkApi;
